module.exports = "<div class=\"tabs__panel\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/tabs/tab.component.html
// module id = 12
// module chunks = 0 1